import store from '../../../core/store';

export const setFilterPresetState = (payload) => {
  return store.dispatch({
    type: 'general.filter_preset/SET_STATE',
    payload,
  });
};

export const showFilterPreset = () => setFilterPresetState({ show: true });
export const hideFilterPreset = () => setFilterPresetState({ show: false });
export const createFilterPreset = (name) => setFilterPresetState({ name });
export const resetFilterPreset = () =>
  setFilterPresetState({ show: false, name: '' });
